// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  intentId: __t.u64().primaryKey().name("intent_id"),
  partyId: __t.u64().name("party_id"),
  identity: __t.identity(),
  gameId: __t.u64().name("game_id"),
  rosterRev: __t.u32().name("roster_rev"),
  state: __t.string(),
  expiresAt: __t.timestamp().name("expires_at"),
  at: __t.timestamp(),
});
